import Vue from 'vue'
import VueRouter from 'vue-router'
import Root from "../views/Root";

Vue.use(VueRouter);

  const routes = [
    {
      path: '/',
      component: Root,
      meta: {
        auth: true
      },
      children: [
        {
          path: '',
          name: 'Root',
          redirect: '/syntax'
        },
        {
          path: '/syntax',
          name: 'Dependencies',
          component: () => import( '../views/Dependencies.vue')
        },
        {
          path: '/codes',
          name: 'Codes',
          component: () => import( '../views/Codes.vue')
        },
        {
          path: '/iso2loc',
          name: 'Iso2LocCodeDependencies',
          component: () => import( '../views/IsoCodeToLocationCodeDependencies.vue')
        },
        {
          path: '/replacements',
          name: 'Replacements',
          component: () => import( '../views/Replacements.vue')
        },
        {
          path: '/replacements/editor',
          name: 'ReplacementEditor',
          component: () => import( '../views/Replacements.vue'),
          props: {
              viewMode: 'editor'
          }
        },
        {
          path: '/amendments',
          name: 'Amendments',
          component: () => import( '../views/NotImplemented.vue')
        },
        {
          path: '/tags',
          name: 'Tags',
          component: () => import( '../views/Tags.vue')
        },
        {
          path: '/info-popup',
          name: 'Info Popup',
          component: () => import( '../views/NotImplemented.vue')
        },
        {
          path: '/favorites',
          name: 'Favorites',
          component: () => import( '../views/NotImplemented.vue')
        },
        {
          path: '/comments',
          name: 'Comments',
          component: () => import( '../views/NotImplemented.vue')
        },
        {
          path: '/dimensions',
          name: 'Dimensions',
          component: () => import( '../views/NotImplemented.vue')
        },
        {
          path: '/quantities',
          name: 'Quantities',
          component: () => import( '../views/NotImplemented.vue')
        },
        {
          path: '/profile',
          name: 'Profile',
          component: () => import( '../views/NotImplemented.vue')
        },
        {
          path: '/changePassword',
          name: 'ChangePassword',
          component: () => import( '../components/Profile/ChangePassword.vue')
        },
        {
          path: '/termsOfUse',
          name: 'TermsOfUse',
          component: () => import( '../components/TermsOfUse.vue')
        },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import( '../views/Login.vue'),
      props: {
        view: 'login'
      }
    },
    {
      path: '/forgotPassword',
      name: 'ForgotPassword',
      component: () => import( '../views/Login.vue'),
      props: {
        view: 'forgotPassword'
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import( '../views/Login.vue'),
      props: {
        view: 'register'
      }
    },
    {
      path: '/verify/:uuid',
      name: 'VerifyRegistration',
      component: () => import( '../views/Login.vue'),
      props: route => ({
        view: 'verify',
        uuid: route.params.uuid
      })
    },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

Vue.router = router;
export default router


/*
* route nesting:
* eingeloggt
* und ausgeloggt : wrapper
*
*
* */